var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.2",
    style: {
      enableBackground: "new 0 0 17.2 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2,8.1c-0.3,0.3-0.6,0.5-0.9,0.7c-0.5,0.3-0.8,0.8-0.8,1.5h-2c-0.1-0.7,0-1.5,0.6-2C8.5,8,8.9,7.8,9.2,7.5 s0.6-0.7,0.7-1.1s-0.2-1-0.7-1.2C8.6,5,7.9,5.2,7.6,5.7C7.5,6,7.4,6.3,7.2,6.7H5.4c-0.2-1,0.4-2.2,1.3-2.8c1.3-0.8,3.5-0.6,4.6,0.4 S12.3,7.1,11.2,8.1z M8.5,13.9c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.3,1.2-1.3s1.3,0.5,1.3,1.3C9.7,13.3,9.2,13.9,8.5,13.9z M7.7,0.1 C3.8,0.5,0.9,3.3,0.2,7c-0.9,4.6,2.1,9.2,6.7,10.1c0.2,0,2.7,0.3,4.6-0.3c3.2-1.2,5.1-3.5,5.7-6.9c0-0.1,0.3-2.8-0.8-5.1 C14.8,1.7,11.5-0.4,7.7,0.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfo);
export default __webpack_public_path__ + "static/media/ico-info.5d14754c9c8d54b3a1c4c1bc0653160c.svg";
export { ForwardRef as ReactComponent };